<isav-projects-shared-landing-page></isav-projects-shared-landing-page>

<div class="page-container page-container-vertical">
    <isav-latest-content></isav-latest-content>
    <isav-partners></isav-partners>
</div>
